<template>
  <div>
    <div class="module pageContainer">
        <!-- 顶部搜索 -->
        <div class="search">
          <el-input v-model="search" style="width: 150px"></el-input>
          <el-button type="primary"  @click.stop.prevent="onSearch">查询</el-button>
        </div>
        <div class="resultArea u-border">
          <div class="button">
                <el-button type="primary" @click.stop="onShowAll">批量显示</el-button>
                <el-button type="primary" @click.stop="onDeleteAll">批量删除</el-button>
                <el-button type="primary" @click.stop="onHideAll">批量隐藏</el-button>
                <el-button type="primary" class="lst-button" @click.stop="onAdd">
                  <span>新建新闻</span>
                  <span >+</span>
                </el-button>
          </div>
          <div class="tableList">
              <el-table
              empty-text="抱歉，暂无相关数据"
              style="width: 100%"
              v-loading="tableLoad"
              :data="tableData"
              @selection-change="onTableSelectionChange"
              @sort-change="onTableSortChange"
              @cell-click="onCellClick">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="title" label="标题"></el-table-column>
              <el-table-column prop="publish_time" label="发布时间" ></el-table-column>
              <el-table-column prop="view_count" label="浏览次数" ></el-table-column>
              <el-table-column prop="indexing" label="新闻排序" ></el-table-column>
              <el-table-column  label="操作" >
                <template slot-scope="scope">
                  <el-button
                    type="text" size="small"
                    @click.stop="onChange(scope.row)">
                    {{scope.row.status == 0 ? '隐藏' : '显示'}}
                  </el-button>
                  <el-button
                    type="text" size="small"
                    @click.stop="onDelete(scope.row)">
                    删除
                  </el-button>
                  <el-button
                    type="text" size="small"
                    @click.stop="onUpdate(scope.row)">
                    编辑
                  </el-button>
                </template>
              </el-table-column>
                
              </el-table>
          </div>
          <PaginationCom
              :pageData="pageData"
              @size-change="onPageSizeChange"
              @current-change="onCurrentPageChange">
          </PaginationCom>
        </div>
    </div>
  </div>
</template>

<script>
    import { PAGINATION } from '@/helpers/baseData';
    import PaginationCom from '@/views/_common/PaginationCom';
    import { pushToWhere, joinSql } from '@/utils/searchParams';
          // 接口
    import { getNewsData, deleteNews, deleteManyNews, changeNewsStatus } from '@/api/apii';
    export default {
        name: 'news',
        inject: ['myMessage'],
        components: {
          'PaginationCom': PaginationCom
        },
        data () {
          return {
            pageData: {
            total: 5,
            pageSize: PAGINATION.pageSize,
            currentPage: 1,
            selectionData: []
          },
            tableData: [],
            form: '',
            tableLoad: false,
            tableOrderBy: [],
            search: ''
          };
        },
        methods: {
          onCellClick (row) {
            this.$router.push({
              path: `${this.$route.path}/${row.id}`
            });
          },
          onPageSizeChange (size) {
            this.pageData.pageSize = size;
            this.pageData.currentPage = 1;
            this.requestList();
          },
          onCurrentPageChange (page) {
            this.pageData.currentPage = page;
            this.requestList();
          },
          onTableSelectionChange (rows) {
            this.selectionData = rows;
          },
          onTableSortChange () {

          },
          requestList () {
            getNewsData(this.handleFormData())
              .then(res => {
                this.handleListData(res);
              })
              .catch(() => {
                this.myMessage.megError('查询失败,请重试');
              })
              .finally();
          },
          handleFormData () {
            const requestData = {
              page: this.pageData.currentPage,
              limit: this.pageData.pageSize,
              orderBy: this.tableOrderBy,
              where: []
            };
            
            pushToWhere(requestData.where, joinSql('title', 'like', this.search, ''));
            return requestData;
          },
          handleListData (res) {
              this.pageData.total = res.count;
              this.tableData = res.datalist;
          },
          onAdd () {
            this.$router.push({ path: `${this.$route.path}/add` });
          },
          onDelete (row) {
             deleteNews(row.id)
             .then((res) => {
                if (res.data != null) {
                  this.requestList();
                }
             })
             .catch(() => {
                this.myMessage.megError('删除失败,请重试');
             });
          },
          onDeleteAll () {
            if (this.selectionData.length < 1) {
              this.myMessage.megError('请选择数据');
              return;
            }
            const requestData = {
              news_ids: []
            };
            this.selectionData.forEach(item => {
              requestData.news_ids.push(item.id);
            });
            deleteManyNews(requestData)
            .then((res) => {
              if (res.data !== '') {
                this.selectionData = [];
                this.requestList();
              }
            })
            .catch(() => {
              this.myMessage.megError('删除失败,请重试');
            });
          },
          onHideAll () {
            if (this.selectionData.length < 1) {
              this.myMessage.megError('请选择数据');
              return;
            }
            const requestData = {
              ids: [],
              status: 0
            };
            this.selectionData.forEach(item => {
              requestData.ids.push(item.id);
            });
            changeNewsStatus(requestData)
            .then((res) => {
              if (res.data !== '') {
                this.selectionData = [];
                this.requestList();
              }
            });
          },
          onShowAll () {
            if (this.selectionData.length < 1) {
              this.myMessage.megError('请选择数据');
              return;
            }
            const requestData = {
              ids: [],
              status: 1
            };
            this.selectionData.forEach(item => {
              requestData.ids.push(item.id);
            });
            changeNewsStatus(requestData)
            .then((res) => {
              if (res.data !== '') {
                this.selectionData = [];
                this.requestList();
              }
            });
          },
          onSearch () {
            this.pageData.total = 0;
            this.pageData.currentPage = 1;
            this.selectionData = [];
            this.requestList();
          },
          onUpdate (row) {
            this.$router.push({ path: `${this.$route.path}/update/${row.id}` });
          },
          onChange (row) {
            const requestData = {
              ids: [row.id]
            };
            if (row.status === 0) {
              requestData.status = 1;
            } else {
              requestData.status = 0;
            }
            changeNewsStatus(requestData)
            .then((res) => {
              if (res.data !== '') {
                this.requestList();
              }
            });
          }
        },
        created () {
          this.requestList();
        }
    };
</script>

<style>
  .search{
    position: relative;
    left: 850px;
    top: 10px;
  }
  .button{
    margin-top: 10px;
    margin-bottom: 5px;
    position: relative;
  }
  el-input{
    width: 40px;
  }
  .button .lst-button{
    position: absolute;
    right: 20px;
  }
</style>
